'use strict';

var $               = require('jquery');
var Core            = require('../core/core.js');
var InspectorButton = require('./inspector__button.js');

/**
 * Creates an inspector button
 *
 * @class
 */

class InspectorButtonGroup extends Core {

	_defaults() {
		return {
			target: '.js-editor',
			fields: {}
		};
	}

	constructor(options) {
		super(options);

		this.template = `
			<div class="editor__inspector__item editor__inspector__item--center"></div>
		`;

		super.render();
	}

	addButton(title,icon){
		return new InspectorButton({
			target: this.$el,
			fields: {
				'title': title,
				'icon': icon,
			}
		});
	}

}
module.exports = InspectorButtonGroup;